module.exports = __webpack_public_path__ + "img/maestro.fba9f2ab.svg";